import { render, staticRenderFns } from "./boxCitySelectSheng.vue?vue&type=template&id=287b3392&scoped=true"
import script from "./boxCitySelectSheng.vue?vue&type=script&lang=js"
export * from "./boxCitySelectSheng.vue?vue&type=script&lang=js"
import style0 from "./boxCitySelectSheng.vue?vue&type=style&index=0&id=287b3392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b3392",
  null
  
)

export default component.exports